import { useTranslations } from '@vocab/react';
import { Box, IconDesktop, IconMobile, Stack, Text } from 'braid-design-system';
import React from 'react';

import { type PreviewLayout, PreviewLayoutEnum } from '../../types';

import translations from './.vocab';

interface Props {
  layout: PreviewLayout;
  onLayoutClick: (value: PreviewLayout) => void;
}

export const PreviewLayoutSelector = ({ layout, onLayoutClick }: Props) => {
  const { t } = useTranslations(translations);

  const handleLayoutClick = (value: PreviewLayout) => {
    onLayoutClick(value);
  };

  const desktopItemTone =
    layout === PreviewLayoutEnum.DESKTOP ? 'formAccent' : 'secondary';
  const mobileItemTone =
    layout === PreviewLayoutEnum.MOBILE ? 'formAccent' : 'secondary';

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Box
        component="button"
        type="button"
        cursor="pointer"
        onClick={() => handleLayoutClick(PreviewLayoutEnum.DESKTOP)}
      >
        <Stack space="small" align="center">
          <IconDesktop tone={desktopItemTone} />
          <Text size="small" tone={desktopItemTone}>
            {t('preview-layout-selector-desktop')}
          </Text>
        </Stack>
      </Box>
      <Box marginRight="gutter" />
      <Box
        component="button"
        type="button"
        cursor="pointer"
        onClick={() => handleLayoutClick(PreviewLayoutEnum.MOBILE)}
      >
        <Stack space="small" align="center">
          <IconMobile tone={mobileItemTone} />
          <Text size="small" tone={mobileItemTone}>
            {t('preview-layout-selector-mobile')}
          </Text>
        </Stack>
      </Box>
    </Box>
  );
};
